<template>
    <crud-facecade
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :tableHeight="tableHeight"
        :addButton="{ permission: 'drug_way:create' }"
        :updateButton="{ permission: 'drug_way:update' }"
    >
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `DrugWay`,
    props: {

    },
    data() {
        return {
            title: `基础数据-用药途径`,
            url: {
                baseURL: `/api/AcisSystem/AddDrugWay`,
                get: () => {
                    return new Promise((resolve) => {
                        let req = this.myaxios.get(`/api/AcisSystem/AddDrugWay/GetAll`)
                        req.then(data => {
                            resolve(data)
                        })
                    })
                }
            },
            buttons: []
        }
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `number`,
                prop: `display_order`,
                label: `排序`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                readonly: false,
                sortable: true,
                isDisplayOrder: true
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `180`,
                isListable: false,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: false,
                sortable: false,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `his_name`,
                label: `His名称`,
                width: `250`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true
            }, {
                type: `select`,
                prop: `is_continue`,
                label: `是否连续`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: `enum_bool`,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                readonly: false,
                options: `is_enabled`,
                default: false
            }]
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Drug/DrugWay.vue